import { habitsApi } from '../api';
import { habitsRepo } from '../db/habits';
import { checkinsRepo } from '../db/checkins';
import { freezesRepo } from '../db/freezes';
import { metaRepo } from '../db/meta';
import { db } from '../db';

/**
 * Pull all server-side habits + their check-in history into Dexie.
 * Server is the source of truth — local rows in 'local' state are preserved
 * by the repo upsert logic, so any pending mutations survive.
 */
export async function pullAll(userId) {
  const data = await habitsApi.list();
  const serverHabits = data.habits || [];

  for (const h of serverHabits) {
    await habitsRepo.upsertFromServer({ ...h, userId });
  }

  // Remove local 'synced' habits that no longer exist server-side (deleted on
  // another device). Anything in 'local' state is preserved.
  const serverIds = new Set(serverHabits.map((h) => h.habitId));
  const localHabits = await db.habits.where('userId').equals(userId).toArray();
  for (const h of localHabits) {
    if (h.syncStatus !== 'synced') continue;
    if (h.habitId.startsWith('local-')) continue;
    if (!serverIds.has(h.habitId)) {
      await db.habits.delete(h.habitId);
      await db.checkins.where('habitId').equals(h.habitId).delete();
    }
  }

  for (const h of serverHabits) {
    try {
      const history = await habitsApi.history(h.habitId);
      const dates = (history.history || []).map((row) => row.date);
      await checkinsRepo.replaceServerSetForHabit(userId, h.habitId, dates);
      await freezesRepo.replaceServerSetForHabit(userId, h.habitId, history.freezes || []);
    } catch (err) {
      // Per-habit history failures shouldn't abort the whole pull.
      console.warn('history pull failed for', h.habitId, err);
    }
  }

  await metaRepo.setLastSyncAt(new Date().toISOString());
}
